/* app/page/all */
/*global iFrameResize */

define(
	'app/page/all',[

	'jquery',
	'app/ui/modal/age-gate',
	'util/lazyload',
	'app/ui/nav/load',
	'app/ui/track/load',
	'app/ui/rotator/rotator',
	'app/ui/accordion/accordion',
	'app/ui/filter/filter',
	'app/ui/video/video.player',
	'app/ui/map/map.load',
	'app/ui/form/form.umbraco',
	'app/ui/social/instagram-timeline',
	'app/ui/charts/charts',
	'app/ui/logIn/login',
	'magnificPopup',
	'phatfingaz',
	'hoverdir'
	],

	function ($, AgeGate, LazyLoad, NavLoad, TrackLoad, Rotator, Accordion, Filter, VideoPlayer, MapLoad, UmbracoForms, InstagramTimeline, Charts, LogIn) {

		'use strict';

		TrackLoad.init();
		NavLoad.init();
		LazyLoad.init();

		var $ageGate = $('.js-age-gate');
		if ($ageGate.length) {
			AgeGate.init($ageGate);
		}

		if( $('.js-header-members').length ){
			require(['app/page/members']); 
		}

		if ($('#iframe').length) {
			require(['iframeresizer'], function() {
				iFrameResize({/*log: true*/ }, '#iframe');
			});
		}

		$('.js-hot').phatFingaz();

		$('.js-hoverdir').each(function() {
			$(this).hoverdir();
		});

		// Rotators
		var $rotators = $('.js-rotator');
		if ($rotators.length) {
			Rotator.init($rotators);
		}

		// Maps
		var $maps = $('.js-map');
		if ($maps.length) {
			MapLoad.init($maps);
		}

		//GoogleMap Marco
		var $mapCover = $('.js-map-cover');
		if ($mapCover.length) {
			$mapCover.on('click',
				function(event) {
					var $target = $(event.target);
					$target.remove();
				});
		}



		// Accordion
		Accordion.init();

		if ($('.js-filter').length) {
			Filter.init();
		}

		// Video Macros
		VideoPlayer.init();

		//header language select
		var $headerLanguageLink = $('.js-header-language');
		var $language = $('.js-language');
		if ($('.no-touch').length) {
			require(['hoverIntent'], function () {
				$language.hoverIntent({
					over: headerLanguageToggle,
					out: headerLanguageToggle,
					interval: 30
				});
			});

		} else {
			$headerLanguageLink.on('click', function (e) {
				e.preventDefault();
				if ($language) {
					headerLanguageToggle();
				}
			});
		}
		function headerLanguageToggle() {
			$language.toggleClass('is-expanded');
		}

		// QR Image Lightbox
		$('.js-lightbox-image-foot-qr')
		.magnificPopup({
			type: 'image',
			image: {
				markup: '<div class="mfp-figure">' +
				'<div class="mfp-img"></div>' +
				'</div>'
			}
		});

		// Umbraco Forms
		// init function will load required dependencies if an umbraco form is present
		UmbracoForms.init();

		//back to top animation
		$('.js-back-to-top').click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 800);
			return false;
		});


		//customized instagram timeline
		InstagramTimeline.init();
		Charts.init();


		// header search form action switch
		var $searchBtn = $('.js-header__search-btn');
		$searchBtn.on('click', function (event) {
			event.preventDefault();
			var $form = $( event.target).closest('form');
			if ($form.find('.js-radio-group').length) {
				if ($form.find('.js-radio-group').find('input:checked').val() === 'wineries') {
					$form.attr('action', $form.attr('data-winery-directory'));
				}
			}
			$form.submit();
		});


		//for fix ios body click no work
		var isiOS = (navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false);
		if (isiOS === true) {

			// Store -webkit-tap-highlight-color as this gets set to rgba(0, 0, 0, 0) in the next part of the code
			var tempCSS = $('a').css('-webkit-tap-highlight-color');

			$('body').css('cursor', 'pointer')                                    // Make iOS honour the click event on body
					 .css('-webkit-tap-highlight-color', 'rgba(0, 0, 0, 0)');     // Stops content flashing when body is clicked

			// Re-apply cached CSS
			$('a').css('-webkit-tap-highlight-color', tempCSS);
		}

		LogIn.init();





	});
